import * as Regex from './regex';
import Routes from './routes';
import * as Value from './value';
import * as Enums from './enums';
import Paths from './paths';
import Configs from './config';
import * as Colors from './color';
import * as Headers from './header';
export { Regex, Routes, Value, Enums, Paths, Configs, Colors, Headers };

export const DatePattern = {
  DATE: 'YYYY-MM-DD',
  DATE_SECOND: 'YYYY/MM/DD',
  DATE_TIME: 'YYYY-MM-DD HH:mm:ss',
  TIMESTAMP: 'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
  SHORT_DATE: 'DD-MM',
  FULL_DATE: 'YYYY年MM月DD日 (dd)',
  FULL_DATE_SECOND: 'YYYY/MM/DD (ddd)',
  FULL_DATE_THIRD: 'YYYY/MM/DD HH:mm',
};
export const TEXT_AREA = 1000;

export const receptionManagementHead: ITableHeader[] = [
  {
    column: 'imageUrlAccess',
    label: 'common.image_url_access',
    width: 10,
  },
  {
    column: 'imageUrlRegister',
    label: 'common.image_register',
    width: 10,
  },
  {
    column: 'securityBoxName',
    label: 'common.device_terminal',
    width: 10,
  },
  {
    column: 'companyName',
    label: 'common.company_name',
    width: 10,
  },
  {
    column: 'fullNameUser',
    label: 'common.full_name',
    width: 10,
  },
  {
    column: 'phoneNumber',
    label: 'common.telephone_number',
    width: 10,
  },
  {
    column: 'deliveryDestination',
    label: 'common.delivery_destination',
    width: 10,
  },
  {
    column: 'carNumber',
    label: 'common.car_number',
    width: 10,
  },
  {
    column: 'checkinTime',
    label: 'history_driver_management.checkInTime',
    width: 10,
  },
  {
    column: 'checkoutTime',
    label: 'history_driver_management.checkOutTime',
    width: 10,
  },
  {
    column: 'durationMinutes',
    label: 'history_driver_management.duration_minutes',
    width: 10,
  },
  {
    column: 'boxNumber',
    label: 'history_driver_management.box_number',
    width: 10,
  },
  {
    column: 'status',
    label: 'common.status',
    width: 4,
  },
];

export const monthlyOverstayCountHead: ITableHeader[] = [
  {
    column: 'id',
    label: 'common.id',
    width: 6,
  },
  {
    column: 'companyName',
    label: 'common.company_name',
    width: 12,
  },
  {
    column: 'numberOfTime',
    label: 'dashboard_screen.number_of_times',
    width: 12,
  },
];

export const driveManagementHead: ITableHeader[] = [
  {
    column: 'image',
    label: 'common.image_register',
    width: 6,
  },
  {
    column: 'status',
    label: 'common.status',
    width: 10,
  },
  {
    column: 'companyName',
    label: 'common.company_name',
    width: 15,
  },
  {
    column: 'fullNameUser',
    label: 'common.full_name',
    width: 15,
  },
  {
    column: 'phoneNumber',
    label: 'common.telephone_number',
    width: 15,
  },
  {
    column: 'deliveryDestination',
    label: 'common.delivery_destination',
    width: 15,
  },
  {
    column: 'carNumber',
    label: 'common.car_number',
    width: 10,
  },
  {
    column: 'createdAt',
    label: 'common.date_register',
    width: 10,
  },
];

export const DAILY_REPORT_TABLE_HEADERS: ITableHeader[] = [
  {
    column: 'imageUrlAccess',
    label: 'common.image_url_access',
    width: 10,
  },
  {
    column: 'imageUrlRegister',
    label: 'common.image_register',
    width: 10,
  },
  {
    column: 'securityBoxName',
    label: 'common.device_terminal',
    width: 10,
  },
  {
    column: 'companyName',
    label: 'common.company_name',
    width: 10,
  },
  {
    column: 'fullNameUser',
    label: 'common.full_name',
    width: 10,
  },
  {
    column: 'phoneNumber',
    label: 'common.telephone_number',
    width: 10,
  },
  {
    column: 'deliveryDestination',
    label: 'common.delivery_destination',
    width: 10,
  },
  {
    column: 'carNumber',
    label: 'common.car_number',
    width: 10,
  },
  {
    column: 'checkinTime',
    label: 'history_driver_management.checkInTime',
    width: 10,
  },
  {
    column: 'checkoutTime',
    label: 'history_driver_management.checkOutTime',
    width: 10,
  },
  {
    column: 'durationMinutes',
    label: 'history_driver_management.duration_minutes',
    width: 10,
  },
  {
    column: 'boxNumber',
    label: 'history_driver_management.box_number',
    width: 10,
  },
];

export const DAILY_REPORT_STAT_TABLE_HEADERS: ITableHeader[] = [
  {
    column: 'title',
    label: '',
    width: 20,
  },
  {
    column: 'securityBoxName',
    label: '',
    width: 20,
  },
  {
    column: 'visitZeroToTwo',
    label: 'daily_report.visit_zero_to_two',
    width: 10,
  },
  {
    column: 'visitTwoToFour',
    label: 'daily_report.visit_two_to_four',
    width: 10,
  },
  {
    column: 'visitFourToSix',
    label: 'daily_report.visit_four_to_six',
    width: 10,
  },
  {
    column: 'visitSixToEight',
    label: 'daily_report.visit_six_to_eight',
    width: 10,
  },
  {
    column: 'visitEightToTen',
    label: 'daily_report.visit_eight_to_ten',
    width: 10,
  },
  {
    column: 'visitTenToTwelve',
    label: 'daily_report.visit_ten_to_twelve',
    width: 10,
  },
  {
    column: 'visitTwelveToFourteen',
    label: 'daily_report.visit_twelve_to_fourteen',
    width: 10,
  },
  {
    column: 'visitFourteenToSixteen',
    label: 'daily_report.visit_fourteen_to_sixteen',
    width: 10,
  },
  {
    column: 'visitSixteenToEighteen',
    label: 'daily_report.visit_sixteen_to_eighteen',
    width: 10,
  },
  {
    column: 'visitEighteenToTwenty',
    label: 'daily_report.visit_eighteen_to_twenty',
    width: 10,
  },
  {
    column: 'visitTwentyToTwentytwo',
    label: 'daily_report.visit_twenty_to_twentytwo',
    width: 10,
  },
  {
    column: 'visitTwentyTwoToTwentyFour',
    label: 'daily_report.visit_twentytwo_to_twentyfour',
    width: 10,
  },
  {
    column: 'total',
    label: 'daily_report.total',
    width: 10,
  },
];

export const preRegistrationListHead: ITableHeader[] = [
  {
    column: 'image',
    label: 'common.image_register',
    width: 6,
  },
  {
    column: 'status',
    label: 'common.status',
    width: 10,
  },
  {
    column: 'companyName',
    label: 'common.company_name',
    width: 15,
  },
  {
    column: 'fullNameUser',
    label: 'common.full_name',
    width: 15,
  },
  {
    column: 'phoneNumber',
    label: 'common.telephone_number',
    width: 15,
  },
  {
    column: 'deliveryDestination',
    label: 'common.delivery_destination',
    width: 15,
  },
  {
    column: 'carNumber',
    label: 'common.car_number',
    width: 10,
  },
  {
    column: 'createdAt',
    label: 'common.date_register',
    width: 10,
  },
];

export const DRIVER_MANAGEMENT_DETAIL_HEADER: ITableHeader[] = [
  {
    column: 'imageUrlRegister',
    label: 'common.image_url_access',
    width: 10,
  },
  {
    column: 'deviceName',
    label: 'common.device_terminal',
    width: 10,
  },
  {
    column: 'companyName',
    label: 'common.company_name',
    width: 10,
  },
  {
    column: 'fullNameUser',
    label: 'common.full_name',
    width: 10,
  },
  {
    column: 'phoneNumber',
    label: 'common.telephone_number',
    width: 10,
  },
  {
    column: 'deliveryDestination',
    label: 'common.delivery_destination',
    width: 10,
  },
  {
    column: 'carNumber',
    label: 'common.car_number',
    width: 10,
  },
  {
    column: 'checkinTime',
    label: 'history_driver_management.checkInTime',
    width: 10,
  },
  {
    column: 'checkoutTime',
    label: 'history_driver_management.checkOutTime',
    width: 10,
  },
  {
    column: 'durationMinutes',
    label: 'history_driver_management.duration_minutes',
    width: 10,
  },
  {
    column: 'boxNumber',
    label: 'history_driver_management.box_number',
    width: 10,
  },
];
